import iconsPng from '@/assets/img/png/icons';
import svgIcons from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import { FORM_FIELD_WIDTH, SUPPORT_TEAM_CARD_HEIGHT, SUPPORT_TEAM_CARD_WIDTH } from '@/constants/dimensions';
import colors from '@/theme/colors';
import { Card, HStack, Image, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import UserLocationUpdateModal from '../UserLocationUpdateModal';
import { useAppStore } from '@/store/useAppStore';
import { TUser } from '@/types/User.types';
import { useQueryClient } from '@tanstack/react-query';
import queryKeys from '@/constants/queryKeys';
import { useNavigate } from '@tanstack/react-router';

const LocationNotSetCard = () => {
  const navigate = useNavigate();
  const { setUser } = useAppStore();
  const queryClient = useQueryClient();

  const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);

  const onLocationUpdateSuccess = (user: TUser) => {
    queryClient.resetQueries({ queryKey: [queryKeys.user.dashboard] });

    setUser(user); // to put the user's new location in the store

    setIsLocationModalVisible(false);

    navigate({ to: '/directory/therapist' });
  };

  return (
    <VStack width={'100%'} alignItems={'center'}>
      <Card
        size="sm"
        width={SUPPORT_TEAM_CARD_WIDTH}
        height={SUPPORT_TEAM_CARD_HEIGHT}
        variant={'elevated'}
        borderRadius={'8px'}
        padding={'20px'}
        shadow={'0px 0px 20px 0px rgba(0, 65, 121, 0.15)'}
      >
        <HStack
          width="100%"
          paddingBottom={'20px'}
          gap={'20px'}
          justifyContent={'center'}
          marginTop={'30px'}
          marginBottom={'10px'}
        >
          <Image alt="add-member" src={iconsPng.locationPin} width={100} height={100} />
        </HStack>

        <VStack width={'100%'} height={'100%'} justifyContent={'space-between'} marginBottom={'20px'}>
          <VStack>
            <Text variant={'loraMedium18'} color={'text.mediumGray'} marginY={'24px'}>
              Therapists Not Visible To You
            </Text>
            <Text variant={'urbanistBold16'} color={'text.mediumBlue'} marginBottom={'8px'}>
              What is this, actually?
            </Text>
            <Text variant={'urbanistSemiBoldRegular'} color={'text.mediumBlue'} textAlign={'center'} paddingX={'10px'}>
              To see therapists near you, we need your location (just your city and state). This ensures that you are
              matched with therapists from your vicinity, all while following regulations.
            </Text>
          </VStack>

          <CustomButton
            backgroundColor={colors.extra.white}
            labelColor={colors.primary[500]}
            labelHoverColor={colors.extra.white}
            iconBeforeLabelSvgPath={svgIcons.locationPin}
            iconBeforeLabelSvgColor={colors.primary[500]}
            label={'Set your Location'}
            hoverBackgroundColor="primary.500"
            borderColor={colors.primary[500]}
            borderHoverColor={colors.primary[500]}
            onClick={() => setIsLocationModalVisible(true)}
            width={FORM_FIELD_WIDTH}
            noShadow
          />
        </VStack>
      </Card>

      <UserLocationUpdateModal
        isLocationModalVisible={isLocationModalVisible}
        setIsLocationModalVisible={setIsLocationModalVisible}
        onSuccess={onLocationUpdateSuccess}
      />
    </VStack>
  );
};

export default LocationNotSetCard;
